import React from 'react';
import { GridColumn } from '@progress/kendo-react-grid';
import { isSome } from 'core/utils';
import { BaasicHeaderCellData } from 'core/stores';
import renderIf from './templates/renderIf';
import _ from 'lodash';

export default function initializeTableColumns({ tableData, t, onRowClick, sortable, ...otherProps }) {
	return _.map(tableData.columns, (column, idx) =>
		renderIf(
			isSome(column.selected)
				? column.selected && (column.enabled == null || column.enabled)
				: (true && (column.enabled == null || column.enabled)) || isSome(column.nestedColumns)
		)(
			column.nestedColumns ? (
				// Nested columns.
				<GridColumn
					key={idx}
					title={t(column.title)}
					headerCell={
						column.headerCell
							? props => <column.headerCell {...{ column, t }} {...props} {...otherProps} />
							: <BaasicHeaderCellData {...{ column, t }} {...props} {...otherProps} />
					}
					headerClassName={
						(isSome(column.sortable) && column.sortable === false && 'k-custom-unclickable') ||
						(otherProps.isExpand && idx === 0 ? 'k-sorted-expand' : undefined)
					}
				>
					{_.map(column.nestedColumns, (nestedColumn, idx) => {
						return (
							<GridColumn
								key={nestedColumn.key}
								cell={
									nestedColumn.dataCell
										? props => <nestedColumn.dataCell {...nestedColumn} {...props} {...otherProps} t={t} />
										: null
								}
								headerCell={
									nestedColumn.headerCell
										? props => <nestedColumn.headerCell {...{ ...nestedColumn, t }} {...props} {...otherProps} />
										: <BaasicHeaderCellData {...{ ...nestedColumn, t }} {...props} {...otherProps} />
								}
								headerClassName={
									(isSome(nestedColumn.sortable) && nestedColumn.sortable === false
										? 'k-custom-unclickable'
										: 'is-sortable') || (otherProps.isExpand && idx === 0 ? 'k-sorted-expand' : undefined)
								}
								field={nestedColumn.key}
								title={t(nestedColumn.title)}
								width={
									isSome(nestedColumn.width) ? (nestedColumn.width === false ? undefined : nestedColumn.width) : '164px'
								}
								sortable={isSome(nestedColumn.sortable) ? nestedColumn.sortable : sortable}
								resizable={isSome(nestedColumn.resizable) ? nestedColumn.resizable : true}
								locked={nestedColumn.locked}
								groupable={nestedColumn.groupable}
								className={
									nestedColumn.locked === undefined || nestedColumn.locked == false
										? (isSome(onRowClick) && nestedColumn.type === 'currency' && 'k-custom-clickable right') ||
										  (isSome(onRowClick) && 'k-custom-clickable') ||
										  (nestedColumn.type === 'currency' && 'right') ||
										  undefined
										: otherProps.isExpand
										? 'k-custom-frozen-expand'
										: nestedColumn.isClickable
										? 'k-custom-clickable k-custom-frozen'
										: 'k-custom-frozen'
								}
								editable={nestedColumn.editable}
								editor={nestedColumn.editor}
							/>
						);
					})}
				</GridColumn>
			) : (
				<GridColumn
					key={column.key}
					title={t(column.title)}
					field={column.key}
					locked={isSome(column.locked) ? column.locked : false}
					cell={column.dataCell ? props => <column.dataCell {...column} {...props} {...otherProps} t={t} /> : null}
					headerCell={
						column.headerCell
							? props => <column.headerCell {...column} {...props} {...otherProps} />
							: props => <BaasicHeaderCellData {...{ column, t }} {...props} {...otherProps} />
					}
					headerClassName={
						(column.sortable === false ? 'k-custom-unclickable' : 'is-sortable') ||
						(isSome(column.sortable) && 'k-custom-sortable') ||
						(otherProps.isExpand && idx === 0 ? 'k-custom-frozen k-custom-frozen--expand' : undefined)
					}
					width={isSome(column.width) ? column.width : '164px'}
					sortable={isSome(column.sortable) ? column.sortable : sortable}
					resizable={isSome(column.resizable) ? column.resizable : true}
					className={
						column.locked === undefined || column.locked == false
							? (isSome(onRowClick) && column.type === 'currency' && 'k-custom-clickable right') ||
							  (isSome(onRowClick) && 'k-custom-clickable') ||
							  (column.type === 'currency' && 'right') ||
							  undefined
							: otherProps.isExpand
							? 'k-custom-frozen-expand'
							: column.isClickable
							? 'k-custom-clickable k-custom-frozen'
							: 'k-custom-frozen'
					}
					editable={column.editable}
					editor={column.editor}
				/>
			)
		)
	);
}



// WEBPACK FOOTER //
// ./src/core/utils/initializeTableColumns.js